/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import UsuarioForm from './UsuarioForm';
import * as validations from '../../validations/validations';
import * as usuarioActions from '../../actions/usuarioActions';
import * as roleActions from '../../actions/roleActions';
import * as cursoActions from '../../actions/cursoActions';
import ModalFotoPerfil from './ModalFotoPerfil';

import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';


import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';


class ManageUsuarioForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			usuario:{
                staff:0,
                showModalPerfil:false,
                fechaNacimiento: new moment().format('DD/MM/YYYY')
            }
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "usuario",true).then( (usuario)=>{
            
            
           
            
           let id=this.props.id;
            this.props.cursoActions.getCursoCombo( usuario).then( ()=>{

               })
                .catch(error=>{
                  toastr.error(error);
                });


            this.props.roleActions.getRoleCombo( usuario).then( (u)=>{

               })
                .catch(error=>{
                  toastr.error(error);
                });


            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
            if(id && id>0 ){
                    this.props.usuarioActions.getUsuario(id, usuario).then( user=>{
                       this.setState({"usuario":user});
                   })
                    .catch(error=>{
                      toastr.error(error);
                    }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
    
    }
    
    
     onShowModalPerfil=()=>{
         this.setState({"showModalPerfil":true})
     }
    
     closeModalPerfil=()=>{
         this.setState({"showModalPerfil":false})
     }


    handleChange=(event, data)=> {

        let usuario = this.state.usuario;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.slider){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		usuario[field[0]]= value;
		else{
             if(!usuario[field[0]]){
                    usuario[field[0]]={}
                }
			usuario[field[0]][field[1]]= value;
		}
        
		
        this.setState({"usuario": usuario});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let usuario=this.state.usuario;
              
        if(!validations.requerido(usuario.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(usuario.apellido)){
            errors.apellido=true;
            formIsValid=false;
        }
       
    
         if(!validations.requerido(usuario.profesion)){
            errors.profesion=true;
            formIsValid=false;
        }
        if(!validations.requerido(usuario.resumen)){
            errors.resumen=true;
            formIsValid=false;
        }
        
      
        if(!validations.requerido(usuario.telefono)){
            errors.telefono=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.usuarioActions.save(this.state.usuario, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }
    
    cambiarFoto=(event)=>{
        event.preventDefault();
      
        
         var adjunto=this.state.adjunto;
        
        if(adjunto instanceof File){
        var form_data = new FormData();
        form_data.append('file', adjunto);            
        //let adjuntoUI={"login":this.props.usuarioActual.login};
        form_data.append('usuarioId',this.state.usuario.id);
          
   
            this.props.usuarioActions.saveAdjuntoProfesor(form_data, this.props.user).then((imagen) => {
                toastr.success("Archivo guardado!!!."); 
                let usuario = this.state.usuario;
                usuario.foto = imagen.nombre;
                this.setState({usuario:usuario});
                this.setState({"adjunto": ""});
               this.setState({"showModalPerfil":false})
            }).catch(error=>{
              toastr.error(error.responseJSON.message);
            });
   
        }else{
            
            toastr.error("Debes seleccionar una foto de perfil");
        }
        
       
    }
    
    
    onChangeAdjuntar=(event, data)=> {	
        let datos = this.state.datosAdjunto;
        let field= data.name;		
        let value=	data.value;		
  
        if(data.type == 'file'){
             
            let file = event.target.files[0];
            if (!file){
                return;
            }
           
            
            var Extension = event.target.files[0].name.substring(
                    event.target.files[0].name.lastIndexOf('.') + 1).toLowerCase();

            if (!(Extension == "png" || Extension == "bmp"
                    || Extension == "jpeg" || Extension == "jpg")) {
                
                toastr.error("Solo se permiten imagenes de tipo jpeg, png, jpg y bmp!!!");
                return;
            }
         
            if(event.target.files[0].size<=2097152){
                
                this.setState({"adjunto": event.target.files[0]});    
        
            }else{
                
                toastr.error("No se permiten imagenes mayores a 2 Mb!!!");
                return;
            } 

        }
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <UsuarioForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.usuario}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursosCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    roleCombo={genericFormattedForDropdown(this.props.roleCombo)}
                    onShowModalPerfil={this.onShowModalPerfil}

                />

            <ModalFotoPerfil
                cambiarFoto={this.cambiarFoto}
                showModal={this.state.showModalPerfil}
                closeModal={this.closeModalPerfil}
                onSave={this.cambiarFoto}
                titulo={"Profile Image"}
                onChange={this.onChangeAdjuntar}
                strings={[]}
            />               
                                
                                
            </Segment> 
                                
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        cursoCombo:state.cursoCombo,
        roleCombo:state.roleCombo,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return { 
            userActions: bindActionCreators(userActions, dispatch),
            menuActions:bindActionCreators(menuActions, dispatch),
            cursoActions: bindActionCreators(cursoActions, dispatch),
            roleActions: bindActionCreators(roleActions, dispatch),
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            usuarioActions: bindActionCreators(usuarioActions, dispatch)
	};
}

function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageUsuarioForm));